/**
 * Created by user on 2019/6/11.
 */

export type ITSOverwriteThisFunction<T extends any, F extends (...args: any[]) => any> =
	(this: T, ...args: Parameters<F>) => ReturnType<F>
